<span  class="p-2 badge badge-pill" [ngClass]="styles[stato]">{{ ('stato.' + (stato | lowercase)) | translate }}</span>